import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useTrackingWidgetCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = {
    addParcels: t(MasterTranslation.AddParcels),
    placeholder: t(MasterTranslation.TrackingWidget),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;

  return {
    addParcels: get('add_parcels', fallback.addParcels),
    placeholder: get('tracking_widget_placeholder', fallback.placeholder),
  };
};
